import { addMethod, string } from 'yup';

export default () => {
  addMethod(string, 'validUrl', function () {
    return this.test({
      name: 'validUrl',
      message: 'Enter a valid url',
      test: (value = '') =>
        value.match(/\b((http|https):\/\/?)[^\s()<>]+(?:\([\w\d]+\)|([^[:punct]\s]|\/?))/g),
    });
  });
};
